'use strict';
// =================================================================
//  gsap-init.js — Inicialización de GSAP + ScrollTrigger
//  Cargado deferred en <head>, INMEDIATAMENTE después de animations.min.js.
//  Necesario porque los scripts de sección (image-with-text-overlay.js,
//  layered-images-with-text.js, featured-collection-list.js, background-video.js,
//  vertical-slideshow.js) usan gsap + scrollTrigger en su connectedCallback,
//  que se ejecuta DURANTE la fase de scripts deferred. Si la registración del
//  plugin se hiciera en DOMContentLoaded, llegaría tarde y el parallax/scroll
//  no se aplicaría.
// =================================================================

if (window.gsap) {
    if (window.Power4) {
        gsap.defaults({ ease: Power4.easeOut });
    }
    gsap.config({ nullTargetWarn: false });

    if (window.ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
    }
    // SplitText lo usa image-with-text-overlay.js y slideshow.js — registrar también
    if (window.SplitText) {
        gsap.registerPlugin(SplitText);
    }
}